import { WechatDownloadModal } from "@/components/WechatDownloadModal";
import React, { FC, useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { isWechatBrowser, getImgSrc, getOS } from "@/utils";
import { DOWNLOAD_AUTHENTICATOR_CONFIG } from "@/constants/enum";
import { DownloadOutlined } from "@ant-design/icons";

export const DownloadGA: FC<{}> = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const os = getOS();

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            width: 78,
            height: 78,
            borderRadius: 16,
            boxShadow: "0px 0px 12px 0px #EAEBEE",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            marginTop: 100,
          }}
        >
          <img
            style={{
              width: 64,
              height: 64,
            }}
            alt="logo"
            src={getImgSrc("/ga-download-logo.png")}
          />
        </div>
        <h3
          style={{
            height: 28,
            fontSize: 20,
            fontWeight: 600,
            color: "#293350",
            lineHeight: "28px",
            marginTop: 32,
          }}
        >
          {t("common.googleAuth")}
        </h3>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            style={{
              height: 42,
              minWidth: 184,
            }}
            size="large"
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => {
              if (isWechatBrowser()) {
                setVisible(true);
              } else {
                if (os && Object.keys(DOWNLOAD_AUTHENTICATOR_CONFIG).includes(os)) {
                  // @ts-ignore
                  window.open(`${DOWNLOAD_AUTHENTICATOR_CONFIG?.[os as never].google}`);
                } else {
                  window.open(`${DOWNLOAD_AUTHENTICATOR_CONFIG?.Android.google}`);
                }
              }
            }}
          >
            {t("common.downloadImmediate")}
          </Button>
        </div>
      </div>
      <WechatDownloadModal visible={visible} />
    </>
  );
};
